import { BaseEntity } from "../entities";
import { ApiClient } from "./client"

export class ActivityProvider {
    private static _apiClient = new ApiClient();

    static async get(id: number) {
        return await this._apiClient.get(`/activity/${id}`) as Activity;
    }

    static async getAllByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/activity/by-organisation/all?organisationId=${organisationId}&page=${page}&size=${size}`) as Activity[];
    }

    static async getMyByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/activity/by-organisation/my?organisationId=${organisationId}&page=${page}&size=${size}`) as Activity[];
    }

    static async save(activity: Activity) {
        return await this._apiClient.post('/activity', activity) as number;
    }
}

export interface Activity extends BaseEntity {
    ActivityId: number
    ActivityAssignedTo: number
    ActivityStatus: ActivityStatus
    ActivityType: string
    ActivityAction: string
    ActivityDateTime: string
    ActivityAllDay: boolean
    ActivityDescription: string
    ActivityOrganisationId: number
    ActivityPersonId: number
    ActivityPersonName: string
}

export enum ActivityStatus {
    Planned = 'Planned',
    Active = 'Active',
    Completed = 'Completed',
}
